module.exports = __webpack_public_path__ + "img/telegram-icon1.4530b4b2.png";